import { render, staticRenderFns } from "./SystemCustomNotificationsResponseListItem.vue?vue&type=template&id=3a027974"
import script from "./SystemCustomNotificationsResponseListItem.vue?vue&type=script&lang=js"
export * from "./SystemCustomNotificationsResponseListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports